// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2q-AR","calendarButtons":"ClockData_calendarButtons__3-diR"};